import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';
import { default as __ } from '../../utils';
import { colors } from '../../styles';

let levelHeight = 50;

const PowerBarVertical = ({ power, cb }) => {
  const [isDragging, setDragging] = useState(false);
  const [selected, setSelected] = useState(power);

  useEffect(() => {
    origin.set(origin.get() + power * levelHeight);
  }, []);

  const config = {
    min: 19,
    max: 300,
    threshold: 10,
    shadeB: colors.purple,
    shadeC: colors.accent,
  };

  const yInput = [config.min, config.max];
  const origin = useMotionValue(power);

  const radius = useTransform(origin, yInput, ['2px', '6px']);
  const mark = useTransform(origin, yInput, [config.shadeB, config.shadeC]);

  // drag stuff
  const position = delta => {
    origin.set(
      origin.get() - delta.y >= config.max
        ? config.max
        : origin.get() - delta.y <= config.min
        ? config.min
        : origin.get() - delta.y,
    );
    let newSelection = (origin.get() + delta.y) / levelHeight;
    setSelected(__.roundTo(newSelection, 0));
  };

  return (
    <>
      <div
        className="col-between align-center owl"
        style={{
          maxWidth: '250px',
          marginRight: 'auto',
          marginLeft: 'auto',
        }}
      >
        <motion.div
          className="border-radius"
          style={{
            backgroundColor: colors.accent_alpha,
            width: '44px',
            height: `${config.max}px`,
            borderRadius: radius,
            position: 'relative',
          }}
        >
          <motion.div
            whileTap={{ scale: 1.1 }}
            drag="y"
            dragConstraints={{ top: 0, bottom: 0 }}
            dragElastic={0}
            dragTransition={{
              bounceStiffness: 300,
              timeConstant: 200,
              power: 0.2,
              bounceDamping: 10,
            }}
            dragMomentum={false}
            style={{
              borderRadius: radius,
              position: 'absolute',
              bottom: 0,
              width: '44px',
              height: origin,
              backgroundColor: mark,
            }}
            onDrag={(e, { delta }) => {
              if (isDragging) {
                position(delta);
              }
              return !isDragging;
            }}
            onDragStart={() => setDragging(true)}
            onDragEnd={() => setDragging(false)}
          />
        </motion.div>
        <div className="col-center align-center owl-xs">
          <br />
          <p className="txt-uppercase -accent txt-xl ">{selected}</p>

          <button
            type="button"
            className="io-unbutton pill-button txt-uppercase"
            onClick={() => console.log('e')}
          >
            Guardar nivel
          </button>
          <br />
        </div>
      </div>
    </>
  );
};

export default PowerBarVertical;
